export type QuestionType = "scale" | "text" | "multiple_choice";

export interface ScaleQuestion {
    id: string;
    type: "scale";
    prompt: string;
    min: number;
    max: number;
    min_label?: string;
    max_label?: string;
}

export interface TextQuestion {
    id: string;
    type: "text";
    prompt: string;
}

export interface MultipleChoiceQuestion {
    id: string;
    type: "multiple_choice";
    prompt: string;
    choice_set_id: string;
}

export type Question = ScaleQuestion | TextQuestion | MultipleChoiceQuestion;

export interface Choice {
    id: string;
    label: string;
}

export interface ChoiceSet {
    id: string;
    title?: string;
    choices: Choice[];
}

export interface Assessment {
    id: string;
    title: string;
    description?: string;
    questions: Question[];
}

export interface AssessmentsDocument {
    schema_version: number;
    choice_sets: ChoiceSet[];
    assessments: Assessment[];
    updated_at?: number;
    updated_by?: string;
}

export const EMPTY_ASSESSMENTS_DOCUMENT: AssessmentsDocument = {
    schema_version: 1,
    choice_sets: [],
    assessments: []
};

export type AnswerValue = string | number;
